module.exports = __webpack_public_path__ + "img/ic_32_profile_privatsphaere.85b4f263.svg";